<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-container>
          <client-add-form></client-add-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import ClientAddForm from "@/components/admin/ClientAddForm";
export default {
  components: {ClientAddForm}
}

</script>